/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully looked up a user
 */
export const lookupUserId200Schema = z.object({
  userId: z.string(),
})

/**
 * @description Must provide a valid username, email, or phone number
 */
export const lookupUserId400Schema = APIErrorSchema

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const lookupUserId401Schema = APIErrorSchema

/**
 * @description User not found or not discoverable
 */
export const lookupUserId404Schema = APIErrorSchema

export const lookupUserIdMutationRequestSchema = z
  .object({
    username: z.string().optional(),
    email: z.string().optional(),
    phoneNumber: z.string().optional(),
  })
  .describe("Provide one of username, email, or phoneNumber")

export const lookupUserIdMutationResponseSchema = lookupUserId200Schema
